/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { View, StyleSheet } from 'react-native';

import AccountBoxIcon from '../icons/account-box';
import AccountCircleIcon from '../icons/account-circle';
import AddAttachmentIcon from '../icons/add-attachment';
import ArrowBackIcon from '../icons/arrow-back';
import AddBoxIcon from '../icons/add-box';
import ArrowDownIcon from '../icons/arrow-down';
import ArrowLeftIcon from '../icons/arrow-left';
import ArrowRightIcon from '../icons/arrow-right';
import ArrowUpIcon from '../icons/arrow-up';
import BarChart from '../icons/bar-chart';
import BackIcon from '../icons/back';
import BillingIcon from '../icons/billing';
import CheckIcon from '../icons/check';
import CheckboxIcon from '../icons/checkbox';
import CheckboxBlankIcon from '../icons/checkbox-blank';
import CheckboxIndeterminateIcon from '../icons/checkbox-indeterminate';
import ChevronDownIcon from '../icons/chevron-down';
import CodeIcon from '../icons/code';
import DescriptionIcon from '../icons/description';
import DownloadIcon from '../icons/download';
import EditIcon from '../icons/edit';
import ErrorIcon from '../icons/error';
import EventIcon from '../icons/event';
import ExploreIcon from '../icons/explore';
import ExportIcon from '../icons/export';
import GroupIcon from '../icons/group';
import HeadingIcon from '../icons/heading';
import HelpIcon from '../icons/help';
import InfoIcon from '../icons/info';
import KeyBoardLeft from '../icons/keyboard-arrow-left';
import KeyBoardRight from '../icons/keyboard-arrow-right';
import ParagraphIcon from '../icons/paragraph';
import LabelIcon from '../icons/label';
import LibraryBooksIcon from '../icons/library-books';
import ListCheckIcon from '../icons/list-check';
import LocationIcon from '../icons/location';
import LockIcon from '../icons/lock';
import LogoutIcon from '../icons/logout';
import MoneyIcon from '../icons/money';
import MoveIcon from '../icons/move';
import MultipleChoiceIcon from '../icons/multiple-choice';
import OptionHorizIcon from '../icons/outline-horiz';
import PdfIcon from '../icons/pdf';
import PeopleIcon from '../icons/people';
import PersonIcon from '../icons/person';
import PlusCircleIcon from '../icons/plus-circle';
import RadioButtonIcon from '../icons/radio-button';
import RemoveIcon from '../icons/delete';
import RenameIcon from '../icons/rename';
import RoundCheckIcon from '../icons/round-check';
import RoundCloseIcon from '../icons/round-close';
import RoundExclamationIcon from '../icons/round-exclamation';
import SearchIcon from '../icons/search';
import SettingsIcon from '../icons/settings';
import TagIcon from '../icons/tag';
import TextInputIcon from '../icons/text-input';
import WrenchIcon from '../icons/wrench';
import WarningIcon from '../icons/warning';
import VendorProfile from '../icons/vendor-profile';
import VisibilityIcon from '../icons/visibility';
import VisibilityOffIcon from '../icons/visibility-off';
import XCircleIcon from '../icons/x-circle';
import XMarkIcon from '../icons/x-mark';
import ColorPalette from '../icons/color-palette';

import { sizes } from './Constants';

export type IconSize = 'XS' | 'S' | 'M' | 'L' | 'XL' | 'XXL';

let componentsByName = {
  accountBox: AccountBoxIcon,
  accountCircle: AccountCircleIcon,
  addAttachment: AddAttachmentIcon,
  addBox: AddBoxIcon,
  arrowBack: ArrowBackIcon,
  arrowDown: ArrowDownIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  arrowUp: ArrowUpIcon,
  barChart: BarChart,
  back: BackIcon,
  billing: BillingIcon,
  check: CheckIcon,
  checkbox: CheckboxIcon,
  checkboxBlank: CheckboxBlankIcon,
  checkboxIndeterminate: CheckboxIndeterminateIcon,
  chevronDown: ChevronDownIcon,
  code: CodeIcon,
  colorPalette: ColorPalette,
  description: DescriptionIcon,
  download: DownloadIcon,
  edit: EditIcon,
  error: ErrorIcon,
  event: EventIcon,
  explore: ExploreIcon,
  export: ExportIcon,
  group: GroupIcon,
  heading: HeadingIcon,
  help: HelpIcon,
  info: InfoIcon,
  keyboardLeft: KeyBoardLeft,
  keyboardRight: KeyBoardRight,
  label: LabelIcon,
  libraryBooks: LibraryBooksIcon,
  listCheck: ListCheckIcon,
  location: LocationIcon,
  lock: LockIcon,
  logout: LogoutIcon,
  money: MoneyIcon,
  move: MoveIcon,
  multipleChoice: MultipleChoiceIcon,
  optionHoriz: OptionHorizIcon,
  paragraph: ParagraphIcon,
  pdf: PdfIcon,
  people: PeopleIcon,
  person: PersonIcon,
  plusCircle: PlusCircleIcon,
  radioButton: RadioButtonIcon,
  remove: RemoveIcon,
  rename: RenameIcon,
  roundCheck: RoundCheckIcon,
  roundClose: RoundCloseIcon,
  roundExclamation: RoundExclamationIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  tag: TagIcon,
  textInput: TextInputIcon,
  vendorProfile: VendorProfile,
  visibility: VisibilityIcon,
  visibilityOff: VisibilityOffIcon,
  warning: WarningIcon,
  wrench: WrenchIcon,
  xCircle: XCircleIcon,
  xMark: XMarkIcon,
};

export type IconName = keyof typeof componentsByName;

type Props = {
  name: IconName;
  size: IconSize | number;
  color?: string;
  style?: StyleSet;
};

function isNumber(size: IconSize | number): size is number {
  return typeof size === 'number';
}

export default function Icon(props: Props) {
  let { name, size, color, style, ...otherProps } = props;
  let Component = componentsByName[name] || View;
  let sizeNum = isNumber(size) ? size : sizes.icons[size];
  let newStyle = color ? [style, { color }] : style;
  let flatStyle = StyleSheet.flatten(newStyle) as any;
  return (
    <Component
      {...otherProps}
      width={sizeNum}
      height={sizeNum}
      style={flatStyle}
    />
  );
}
